let baseApi = 'http://81.71.31.107:9997/license/v1/open'
export default baseApi


// WEBPACK FOOTER //
// ./src/config.js